/*
 * Script to open Chatwoot widget on click
 * Binds a click handler to #open-chat and waits for Chatwoot to be ready.
 * Works with both DOMContentLoaded and Turbo navigation.
 */
function whenChatwootReady() {
  return new Promise((resolve) => {
    if (window.$chatwoot?.toggle) return resolve();
    let tries = 0;
    const id = setInterval(() => {
      if (window.$chatwoot?.toggle) { clearInterval(id); resolve(); }
      else if (++tries > 100) { clearInterval(id); /* give up quietly */ }
    }, 100);
  });
}

function bindOpenChat() {
  const link = document.querySelector('#open-chat');
  if (!link) return;

  // Assign handler directly to avoid duplicate bindings
  link.onclick = async (e) => {
    e.preventDefault();
    await whenChatwootReady();
    if (window.$chatwoot && typeof window.$chatwoot.toggle === "function") {
      window.$chatwoot.toggle("open");
    }
  };
}

// Bind for first load and Turbo navigation
document.addEventListener('DOMContentLoaded', bindOpenChat);
document.addEventListener('turbo:load', bindOpenChat);
